import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import "./registration.scss";

import { Formik } from "formik";
import { Form, Modal } from "react-bootstrap";
import PhoneInputField from "sharedComponents/PhoneInputField";
import ContractModal from "../../Files/ContractModal";
import ProcessingDataModal from "../../Files/ProcessingDataModal";

import closeEye from "images/closeEye.svg";
import cross from "images/cross.svg";
import openEye from "images/openEye.svg";

import { validationRegistration } from "../../Validation/index";

const Registration = ({
  setRegistrationModal,

  newRegistration,
  getStaticPage,
  offer,
  personalDataPolicy,
  errorRegistration,
  cleanErrorRegistration,
  approvedPhone,

  ...props
}) => {
  useEffect(() => {
    if (approvedPhone === "0") {
      setRegistrationModal(false);
    }
  });
  useEffect(() => {
    getStaticPage("offerAgreement");
    getStaticPage("personalDataPolicy");
  }, []);
  const [modalContractShow, setModalContractShow] = useState(false);
  const [modalProcessingDataShow, setModalProcessingDataShow] = useState(false);
  const [typePassword, setTypePassword] = useState("password");
  const [typeConfirmPassword, setTypeConfirmPassword] = useState("password");

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="registration">
        <p>
          <img
            src={cross}
            className="registration-img"
            onClick={() => {
              cleanErrorRegistration();
              setRegistrationModal(false);
            }}
            alt=""
          />
        </p>
        <Formik
          initialValues={{
            surname: "",
            firstname: "",
            patronymic: "",
            birthday: "",
            phone: "",
            email: "",
            // confirmEmail: "",
            password: "",
            confirmPassword: "",
            processingData: false,
            contract: false
          }}
          validateOnBlur
          onSubmit={async (values) => {
            await newRegistration(values);
          }}
          validationSchema={validationRegistration}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldTouched,
            isValid,
            handleSubmit,
            dirty
          }) => (
            <div className="registration-form">
              <Form>
                <p className="registration-form-title">Регистрация</p>

                <Form.Group className="mb-3">
                  <Form.Label>Фамилия*</Form.Label>
                  <Form.Control
                    autoComplete="new-password"
                    className="registration-placeholder"
                    type="text"
                    name="surname"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={() => setFieldTouched("surname", true)}
                    value={values.surname}
                    isInvalid={touched.surname && errors.surname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.surname}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label> Имя*</Form.Label>

                  <Form.Control
                    autoComplete="new-password"
                    className="registration-placeholder"
                    type="text"
                    name="firstname"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={() => setFieldTouched("firstname", true)}
                    value={values.firstname}
                    isInvalid={touched.firstname && errors.firstname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstname}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Отчество</Form.Label>
                  <Form.Control
                    autoComplete="new-password"
                    className="registration-placeholder"
                    type="text"
                    name="patronymic"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.patronymic}
                    isInvalid={touched.patronymic && errors.patronymic}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.patronymic}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="registration-row">
                  <Form.Group className="mb-3">
                    <Form.Label>Дата рождения*</Form.Label>
                    <Form.Control
                      autoComplete="new-password"
                      className="registration-placeholder"
                      type="date"
                      max="2999-12-31"
                      name="birthday"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onFocus={() => setFieldTouched("birthday", true)}
                      value={values.birthday}
                      isInvalid={touched.birthday && errors.birthday}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.birthday}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <PhoneInputField name="phone" title="Номер телефона" />
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Электронная почта*</Form.Label>

                  <Form.Control
                    autoComplete="new-password"
                    className="registration-placeholder"
                    type="email"
                    placeholder="Email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={() => setFieldTouched("email", true)}
                    value={values.email}
                    isInvalid={touched.email && errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                <div className="registration-row">
                  <Form.Group className="mb-3">
                    <Form.Label>Пароль*</Form.Label>
                    <div className="input-group">
                      <Form.Control
                        autoComplete="new-password"
                        className="registration-placeholder password-form"
                        type={typePassword}
                        name="password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        onFocus={() => setFieldTouched("password", true)}
                        isInvalid={touched.password && errors.password}
                      />
                      {typePassword === "password" ? (
                        <img
                          src={closeEye}
                          alt="eye"
                          onClick={() => setTypePassword("text")}
                          className="eyeIcon"
                        />
                      ) : (
                        <img
                          src={openEye}
                          alt="eye"
                          onClick={() => setTypePassword("password")}
                          className="eyeIcon"
                        />
                      )}
                    </div>
                    {errors.password && touched.password ? (
                      <p className="error-text">{errors.password}</p>
                    ) : (
                      <Form.Text className="text-muted">
                        Пароль должен содержать не менее 6 символов
                      </Form.Text>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Повторить пароль*</Form.Label>
                    <div className="input-group">
                      <Form.Control
                        autoComplete="new-password"
                        className="registration-placeholder password-form"
                        type={typeConfirmPassword}
                        name="confirmPassword"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={() => setFieldTouched("confirmPassword", true)}
                        value={values.confirmPassword}
                        isInvalid={
                          touched.confirmPassword && errors.confirmPassword
                        }
                      />
                      {typeConfirmPassword === "password" ? (
                        <img
                          src={closeEye}
                          alt="eye"
                          onClick={() => setTypeConfirmPassword("text")}
                          className="eyeIcon"
                        />
                      ) : (
                        <img
                          src={openEye}
                          alt="eye"
                          onClick={() => setTypeConfirmPassword("password")}
                          className="eyeIcon"
                        />
                      )}
                    </div>
                    {errors.confirmPassword && touched.confirmPassword ? (
                      <p className="error-text">{errors.password}</p>
                    ) : (
                      ""
                    )}
                  </Form.Group>
                </div>

                <Form.Group className="check-processing-data">
                  <Form.Check
                    type="checkbox"
                    name="processingData"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.processingData}
                    isInvalid={touched.processingData && errors.processingData}
                  />

                  <Form.Label>
                    Я ознакомлен(а) и принимаю условия{" "}
                    <a
                      onClick={() => setModalContractShow(true)}
                      className="check-processing-button"
                    >
                      Договора оферты о сотрудничестве
                    </a>
                  </Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.processingData}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="check-processing-data mb-3">
                  <Form.Check
                    type="checkbox"
                    name="contract"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.contract}
                    isInvalid={touched.contract && errors.contract}
                  />
                  <Form.Label>
                    Я ознакомлен(а) и принимаю условия{" "}
                    <a
                      onClick={() => setModalProcessingDataShow(true)}
                      className="check-processing-button"
                    >
                      Политики конфиденциальности в отношении обработки
                      персональных данных
                    </a>
                  </Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.contract}
                  </Form.Control.Feedback>
                </Form.Group>

                <div>
                  <button
                    type="submit"
                    className="registration-form-btn"
                    disabled={!isValid || !dirty}
                    onClick={handleSubmit}
                  >
                    Далее
                  </button>
                  {errorRegistration ? (
                    <p className="registration-form-error">
                      {errorRegistration}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </Form>
              <ContractModal
                show={modalContractShow}
                onHide={() => setModalContractShow(false)}
                offer={offer}
              ></ContractModal>
              <ProcessingDataModal
                show={modalProcessingDataShow}
                onHide={() => setModalProcessingDataShow(false)}
                personalDataPolicy={personalDataPolicy}
              ></ProcessingDataModal>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ usersStore, documentsStore, modalWindows }) => {
  const {
    newRegistration,
    cleanErrorRegistration,
    registration,
    errorRegistration,
    approvedPhone
  } = usersStore;

  const { getStaticPage, offer, personalDataPolicy } = documentsStore;

  const { setRegistrationModal } = modalWindows;

  return {
    setRegistrationModal,

    newRegistration,
    errorRegistration,
    registration,
    cleanErrorRegistration,
    approvedPhone,

    getStaticPage,
    offer,
    personalDataPolicy
  };
})(observer(Registration));
